module.exports = "/_next/static/images/7977932c931dc735f416a557058fbe75-woman-with-yellow-glasses@3x.jpg";